import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/**
 * TOP ページ 数値強調の List
 * @param props
 * @returns
 */
export const TopNumberList = (props) => {
    const { children, className = '' } = props;
    return (_jsx("ul", Object.assign({ className: clsx('grid grid-cols-1 lg:grid-cols-3', 'gap-y-16 lg:gap-x-[30px]', className) }, { children: children })));
};
